export const getPrivateOrderChatSelector = state => state.privateOrderChat;
